import { doHttp, decode } from '../../utils/json-api'
import { resultSuccess, resultError } from '../../interfaces/base'
import { appErrorFromAnything } from '../../utils/error'

import {
  IUserService,
  GetUser,
  GetUsersEmailData,
} from '../../interfaces/services/user'

import adapters from './adapters'
import { translateWithUserLocale } from '../../utils/i18n'

const userService: (DI: any) => IUserService = (DI) => {
  const getUser: GetUser = async () => {
    try {
      const response = await doHttp({
        method: 'get',
        url: `/api/me`,
      })
      const adapted = decode(adapters.user, response)

      return resultSuccess(adapted)
    } catch (e) {
      console.error(e)
      return resultError(appErrorFromAnything(e))
    }
  }

  const getUsersEmailData: GetUsersEmailData = async (clientId: string) => {
    try {
      const response = await doHttp(
        {
          method: 'get',
          url: `/api/memoria_client_data/${clientId}`,
        },
        { expectedErrorCodes: [422, 404, 400] },
      )
      if (response.status !== undefined) {
        return resultError({
          title: translateWithUserLocale('error.agent_not_found_title'),
          message: translateWithUserLocale('error.agent_not_found_message'),
          statusCode: response.status,
        })
      }

      const adapted = decode(adapters.userEmailData, response)
      return resultSuccess(adapted)
    } catch (e) {
      console.error(e)
      return resultError(appErrorFromAnything(e))
    }
  }

  return {
    getUser,
    getUsersEmailData,
  }
}

export default userService
